import { Box } from 'components/Box'
import { Row } from 'components/Flex'
import WagmiLogo from 'components/Logo/WagmiLogo'
import Web3Status from 'components/Web3Status'
import { ReactElement, ReactNode } from 'react'
import { NavLink, NavLinkProps, useNavigate } from 'react-router-dom'
import styled from 'styled-components/macro'

import { ChainSelector } from './ChainSelector'
import { MenuDropdown } from './components/MenuDropdown'
import * as styles from './style.css'

interface IMenuItem {
  label: string
  url: string
}
interface MenuItemProps {
  href: string
  id?: NavLinkProps['id']
  isActive?: boolean
  children: ReactNode
  dataTestId?: string
  disabled?: boolean
}

const Nav = styled.nav`
  padding: 20px 12px;
  width: 100%;
  height: ${({ theme }) => theme.navHeight}px;
  z-index: 2;
  background: ${({ theme }) => theme.navbarBackground};
`
const StyledMenuItem = styled(NavLink)<{ disabled?: boolean }>`
  padding: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.15px;
  text-decoration: none;
  justify-content: center;
  font-family: 'Lexend Deca', sans-serif;
  transition: background 0.2s ease-in-out;
  color: ${({ theme }) => theme.navbarForeground};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  &.active,
  &:hover {
    color: ${({ theme }) => theme.navbarActiveLinkForeground};
    background: ${({ theme }) => theme.navbarActiveLinkBackground};
  }
`

const menu: IMenuItem[] = [
  { label: 'Trade', url: '/trade/swap' },
  { label: 'Liquidity', url: '/liquidity' },
  { label: 'Strategies', url: 'liquidity/strategies' },
  { label: 'GMI', url: '/gmi' },
  { label: 'Dashboard', url: '/dashboard' },
]

const MenuItem = ({ href, dataTestId, id, isActive, children, disabled }: MenuItemProps) => {
  return (
    <StyledMenuItem
      id={id}
      to={href}
      end
      data-testid={dataTestId}
      className={isActive ? styles.activeMenuItem : styles.menuItem}
      disabled={disabled}
    >
      {children}
    </StyledMenuItem>
  )
}

export const PageTabs = (): ReactElement => {
  return (
    <>
      {menu.map((item, index: number): ReactElement => {
        return (
          <MenuItem key={index} href={item.url}>
            {item.label}
          </MenuItem>
        )
      })}
    </>
  )
}

const Navbar = (): ReactElement => {
  const navigate = useNavigate()

  return (
    <>
      <Nav>
        <Box display="flex" height="full" flexWrap="nowrap">
          <Box className={styles.leftSideContainer}>
            <Box className={styles.logoContainer}>
              <WagmiLogo
                className={styles.logo}
                onClick={() => {
                  navigate({
                    pathname: '/',
                  })
                }}
              />
            </Box>
            <Box display={{ sm: 'flex', lg: 'none' }}>
              <ChainSelector leftAlign={true} />
            </Box>
            <Row style={{ gap: 10 }} display={{ sm: 'none', lg: 'flex' }}>
              <PageTabs />
            </Row>
          </Box>
          <Box className={styles.rightSideContainer}>
            <Row gap="12">
              <Box display={{ sm: 'none', lg: 'flex' }}>
                <ChainSelector />
              </Box>
              <Web3Status />
              <Box marginY={{ sm: '4', md: 'unset' }}>
                <MenuDropdown />
              </Box>
            </Row>
          </Box>
        </Box>
      </Nav>
    </>
  )
}

export default Navbar
